var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"66d81aac5d18d9890cf2bfe2a08bc4623b041948"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["make-and-play-web@make-and-play-inc"]={id:"66d81aac5d18d9890cf2bfe2a08bc4623b041948"};
      